import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { RouterModule, Routes } from '@angular/router';
import { MatListModule } from '@angular/material/list';
import { FeatureFlagGuard } from '../core/services/feature-flag.guard';
import { CommitButtonModule } from '../shared/commit-button/commit-button.module';
import { ErrorMessageModule } from '../shared/error-message/error-message.module';
import { FileUploaderModule } from '../shared/file-uploader/file-uploader.module';
import { SpinnerModule } from '../shared/spinner/spinner.module';
import { MatrixModule } from '../shared/matrix/matrix.module';
import { ProjectTemplateComponent } from './setup-page/project-template/project-template.component';
import { SetupPageComponent } from './setup-page/setup-page.component';
import { UserEditDialogComponent } from './setup-page/user-admin/user-edit-dialog/user-edit-dialog.component';
import { UserListComponent } from './setup-page/user-admin/user-list/user-list.component';
import { ProjectConfigComponent } from './setup-page/project-config/project-config.component';
import { DataDialogComponent } from './setup-page/data-dialog/data-dialog.component';
import { SignatureMatrixTemplateComponent } from './setup-page/signature-matrix-template/signature-matrix-template.component';
import { SignatureMatrixTemplateListComponent } from './setup-page/signature-matrix-template/signature-matrix-template-list/signature-matrix-template-list.component';
import { MatrixEditDialogComponent } from './setup-page/signature-matrix-template/matrix-template-edit-dialog/matrix-template-edit-dialog.component';
import { DisciplineSelectDialogComponent } from './setup-page/signature-matrix-template/discipline-select-dialog/discipline-select-dialog.component';
import { SignatureRoleComponent } from './setup-page/signature-matrix-template/signature-role/signature-role.component';
import { SignatureRoleEditDialogComponent } from './setup-page/signature-matrix-template/signature-role-edit-dialog/signature-role-edit-dialog.component';
import { CheckSheetEditorComponent } from './setup-page/check-sheet-editor/check-sheet-editor.component';
import { EditSignatureMatrixDialogComponent } from './setup-page/check-sheet-editor/edit-signature-matrix-dialog/edit-signature-matrix-dialog.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { CompanyEditorComponent } from './setup-page/company-editor/company-editor.component';
import { MetadataEditorComponent } from './setup-page/metadata-editor/metadata-editor.component';
import { CompanyEditorDialogComponent } from './setup-page/company-editor/company-editor-dialog/company-editor-dialog.component';
import { UserAdminComponent } from './setup-page/user-admin/user-admin.component';
import { SignatureRoleMatrixComponent } from './setup-page/user-admin/signature-role-matrix/signature-role-matrix.component';
import { UserManualDirective } from '../shared/user-manual/user-manual.directive';
import { MonitoringComponent } from './setup-page/monitoring/monitoring.component';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AssignmentRoleModule } from './setup-page/assignment-role/assignment-role.module';
import { UserAvatarModule } from '../shared/user-avatar/user-avatar.module';
import { ProjectConfigSectionComponent } from './setup-page/project-config/project-config-section/project-config-section.component';
import { ConfirmChangeDialogModule } from '../shared/confirm-change-dialog/confirm-change-dialog.module';
import { DirectivesModule } from '../shared/directives/directives.module';

export const routes: Routes = [
  {
    path: 'project-setup',
    component: SetupPageComponent,
    data: {
      title: 'Project Setup',
    },
    canActivate: [FeatureFlagGuard],
  },
];

@NgModule({
  declarations: [
    SetupPageComponent,
    ProjectTemplateComponent,
    UserListComponent,
    UserEditDialogComponent,
    ProjectConfigComponent,
    ProjectConfigSectionComponent,
    DataDialogComponent,
    SignatureMatrixTemplateComponent,
    SignatureMatrixTemplateListComponent,
    MatrixEditDialogComponent,
    DisciplineSelectDialogComponent,
    SignatureRoleComponent,
    SignatureRoleEditDialogComponent,
    CheckSheetEditorComponent,
    EditSignatureMatrixDialogComponent,
    CompanyEditorComponent,
    MetadataEditorComponent,
    CompanyEditorDialogComponent,
    UserAdminComponent,
    SignatureRoleMatrixComponent,
    MonitoringComponent,
  ],
  imports: [
    CommonModule,
    CommitButtonModule,
    DragDropModule,
    FormsModule,
    ErrorMessageModule,
    MatDialogModule,
    MatIconModule,
    MatButtonModule,
    MatSelectModule,
    MatListModule,
    MatInputModule,
    SpinnerModule,
    MatRadioModule,
    MatSnackBarModule,
    MatSortModule,
    MatTabsModule,
    MatChipsModule,
    MatExpansionModule,
    MatTableModule,
    MatDialogModule,
    NgxChartsModule,
    FileUploaderModule,
    ReactiveFormsModule,
    RouterModule.forChild(routes),
    MatPaginatorModule,
    MatButtonToggleModule,
    MatAutocompleteModule,
    UserManualDirective,
    ConfirmChangeDialogModule,
    AssignmentRoleModule,
    MatrixModule,
    UserAvatarModule,
    DirectivesModule,
  ],
})
export class ProjectSetupModule {}
